"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const BaseEntity_1 = tslib_1.__importDefault(require("@integration/offerstore-api-models/src/lib/BaseEntity"));
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const enums_1 = require("../../enums");
const class_transformer_1 = require("class-transformer");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
class GetNextBestBannerResponseBanner extends BaseEntity_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.BannerType)),
    (0, base_models_1.Docs)({
        example: enums_1.BannerType.OFFER,
        description: 'To see whether banner is of type Informational or Offer.',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBannerResponseBanner.prototype, "bannerType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 4, description: 'Offer ranking' }),
    tslib_1.__metadata("design:type", Number)
], GetNextBestBannerResponseBanner.prototype, "ranking", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: '123422',
        description: 'The campaign id which is managed by the Campaign Management Team',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBannerResponseBanner.prototype, "cdtId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-01-20T00:00:00.000Z',
        description: 'Date from which the promotion is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], GetNextBestBannerResponseBanner.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-04-20T00:00:00.000Z',
        description: 'Date until when the promotion is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], GetNextBestBannerResponseBanner.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.bannerType === enums_1.BannerType.OFFER),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Profile identifier',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBannerResponseBanner.prototype, "offerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.bannerType === enums_1.BannerType.OFFER),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FLEX,
        description: 'Proposition duration.',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBannerResponseBanner.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.bannerType === enums_1.BannerType.OFFER),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.GetNextBestOfferResponseOfferIncentiveV2),
    tslib_1.__metadata("design:type", Array)
], GetNextBestBannerResponseBanner.prototype, "incentives", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.bannerType === enums_1.BannerType.OFFER),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.PropositionProduct),
    tslib_1.__metadata("design:type", Array)
], GetNextBestBannerResponseBanner.prototype, "products", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateIf)((o) => o.bannerType === enums_1.BannerType.INFORMATIONAL),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '43f8970a-e808-4474-8f16-14d16297d456',
        description: 'Informational identifier',
    }),
    tslib_1.__metadata("design:type", String)
], GetNextBestBannerResponseBanner.prototype, "informationalId", void 0);
exports.default = GetNextBestBannerResponseBanner;
